import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./components/toastComponent/ToastComponent.scss";
import { keycloak } from "./services/keycloak";
import AppRouter from "./AppRouter";
import "./css/common.scss";
import { ValueProvider } from "./utils/contextAPI/contextAPI";
import { eDetail } from "./utils/constants";

function App() {
   const tokenLogger = async (tokenData) => {
    if (tokenData.token ) {

      window.localStorage.setItem("userToken", tokenData.token);
      const data = await keycloak.loadUserInfo();
      window.localStorage.setItem("userRole", keycloak.realmAccess.roles);
      window.localStorage.setItem("userEmail", data.email);
      window.localStorage.setItem("userId", data.sub);
      window.localStorage.setItem("currentUserName", data.name);
    }
  };
   
  //const [token, refreshToken] = getTokens();
  const [deckId, setDeckId] = useState(null);
  const [userSub, setUserSub] = useState(null);
  const [devices, setDevices] = useState([]);
  const [dimensions, setDimensions] = useState([]);

  const [edetailName, setEdetailName] = useState("");
  const [toggleTemplate, setToggleTemplate] = useState(eDetail);
  const getUserInfo = async () => {
    try {
      const userData = await keycloak.loadUserInfo();
      setUserSub(userData.sub);
    } catch (error) {
      console.log(error);
    }
  };

const eventLogger = async (event) => {
  if (event === "onTokenExpired") {
    toast.error(
      <div className="toast-text-message">
          Session expired. Logging out...
      </div>, 
      {
        onClose: async () => {
          await keycloak.logout({
            redirectUri: window.location.origin,
          });
        },
        position: "top-right",
        autoClose: 150000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        className: "toast-popup toast-error-popup",
      }
    );
    // await keycloak.logout();
  }
};
  return (
    <div className="App">
      <ToastContainer />
      {/* <ReactKeycloakProvider
        initOptions={{ onLoad: "login-required" }}
        authClient={keycloak}
        onEvent={eventLogger}
        onTokens={tokenLogger}
        
      > */}
       <ReactKeycloakProvider
              initOptions={{ onLoad: "login-required" }}
              authClient={keycloak}
              onEvent={eventLogger}
              onTokens={tokenLogger}
              keycloak={keycloak}
            >
        <ValueProvider
          value={{
            deckId: deckId,
            setDeckId: setDeckId,
            setEdetailName: setEdetailName,
            edetailName: edetailName,
            toggleTemplate: toggleTemplate,
            setToggleTemplate: setToggleTemplate,
            userSub: userSub,
            setUserSub: setUserSub,
            devices: devices,
            setDevices: setDevices,
            dimensions: dimensions,
            setDimensions: setDimensions,
          }}
        >
          <AppRouter />
        </ValueProvider>
      </ReactKeycloakProvider>
      <div className="flickeringcol1">
        <span className="flickeringcol2"></span>
        <span className="flickeringcol3"></span>
        <span className="flickeringcol4"></span>
        <span className="flickeringdiv"></span>
        <span className="flickeringHeading"></span>
        <span className="flickeringSubHeading"></span>
        <span className="flickeringPara"></span>
        <span className="flickeringImage"></span>
        <span className="flickeringvideo"></span>
        <span className="flickeringtable"></span>
        <span className="flickeringtabs"></span>
        <span className="flickeringButton"></span>
        <span className="flickeringLink"></span>
        <span className="flickeringform"></span>
        <span className="flickeringLink"></span>
      </div>
    </div>
  );
}

export default App;
